import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-include-exclude-rsvn',
  templateUrl: './invoice-include-exclude-rsvn.component.html',
  styleUrls: ['./invoice-include-exclude-rsvn.component.scss']
})
export class InvoiceIncludeExcludeRsvnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
